var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tool-item2"},[_c('el-dialog',{staticClass:"newDialog",attrs:{"title":"銷售素材","visible":_vm.visible,"height":"100%","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.visible=$event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ad693d2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/ChatToolBar_AttachFileV2.vue
// module id = null
// module chunks = 